import { PermissionType } from '../constants/enums/permission-type-enum';
import userTypeEnum from '../constants/enums/user-type-enum';
import authStore from '../core/stores/auth-store';
import { IRoleVM } from '../models/response/IRoleResponse';
import RoutesConstants from '../shared-components/routes/routes-constants';
import {
  getIsTenantAccessFromLocalStorage,
  getTenantIdFromLocalStorage,
  getTokenFromLocalStorage,
  getUserTypeFromLocalStorage,
} from './localstorage-helper';

export const findRouteAccess = (module: number) => {
  let userPermission: any = authStore.getAllPermission;
  const userRole: string = authStore.getUserType;
  //const isTenantAccess: any = getIsTenantAccessFromLocalStorage();
  if (userRole !== userTypeEnum[0] || userRole !== userTypeEnum[1]) {
    if (userRole === userTypeEnum[0] || userRole === userTypeEnum[1]) {
      if (JSON.stringify(userPermission) === '[]') {
        const permissions = localStorage.getItem('oms_permissions');
        if (permissions) {
          userPermission = JSON.parse(permissions);
        }
      }
      const modulePermission = userPermission.filter(
        (per: IRoleVM) => per.ModuleType == module
      );
      if (modulePermission.length === 1) {
        if (
          modulePermission[0].PermissionType === PermissionType.AllAccess ||
          modulePermission[0].PermissionType === PermissionType.ViewOnly
        ) {
          return omsManagementRouteSetup(module);
        } else {
          return false;
        }
      }
    } else {
      if (JSON.stringify(userPermission) === '[]') {
        const permissions = localStorage.getItem('oms_permissions');
        if (permissions) {
          userPermission = JSON.parse(permissions);
        }
      }
      const modulePermission = userPermission.filter(
        (per: IRoleVM) => per.ModuleType == module
      );
      if (modulePermission.length === 1) {
        return (
          modulePermission[0].PermissionType === PermissionType.AllAccess ||
          modulePermission[0].PermissionType === PermissionType.ViewOnly
        );
      }
      return false;
    }
  } else {
    return omsManagementRouteSetup(module);
  }
};

export const redirectToDefaultRoute = () => {
  const roleType = authStore.userType
    ? authStore.userType
    : localStorage.getItem('oms_userType');

  const userType = getUserTypeFromLocalStorage();

  if (roleType) {
    if (userType === userTypeEnum[0] || userType === userTypeEnum[1]) {
      if (
        (userType === 'SuperAdministrator' || userType === 'DIDManager') &&
        Number(getTenantIdFromLocalStorage()) >= 0
      ) {
        return RoutesConstants.AIMSPortal;
      } else {
        return RoutesConstants.FactoryManagement;
      }
    } else if (userType === userTypeEnum[4]) {
      return RoutesConstants.ProductManagement;
    } else if (userType === userTypeEnum[5]) {
      return RoutesConstants.TrayManagement;
    } else if (userType === userTypeEnum[2] || userType === userTypeEnum[3]) {
      return RoutesConstants.AIMSPortal;
    }
    if (userType === userTypeEnum[6]) {
      return RoutesConstants.OperatorListDetail;
    }
    // else if (userType === userTypeEnum[3]) {
    //   return RoutesConstants.StepManagementOperator;
    // }
    else {
      return RoutesConstants.Login;
    }
  } else if (getTokenFromLocalStorage() === '') {
    return RoutesConstants.Login;
  } else {
    return RoutesConstants.Login;
  }
};

export const omsManagementRouteSetup = (module: number) => {
  return true;
  // const isPriceSchedulerActive = preferenceStore.getPriceSchedulerAccess.isAccessPriceSchedulerActive;
  // const isTenantAccess: any = getIsTenantAccessFromLocalStorage();
  // if (
  //   // ModuleType.BranchManagement === module ||
  //   ModuleType.ParkingManagementList === module
  //   // ||    ModuleType.MediaManagement === module
  // ) {
  //   return isTenantAccess;
  // } else if (ModuleType.PriceSchedular === module) {
  //   return isTenantAccess && isPriceSchedulerActive;
  // }
  // // else if (ModuleType.StepManagement === module || ModuleType.OperatorStepManagement === module) {
  // //   return false;
  // // }
  // else if (
  //   (ModuleType.UserManagement === module ||
  //     ModuleType.CompanyUserManagement === module ||
  //     ModuleType.TenantManagement === module) &&
  //   isTenantAccess === true
  // ) {
  //   return false;
  // } else {
  //   return true;
  // }
};
